/** Dashboard roots match exactly; sections include their nested detail pages. */
export function matchesNavigationPath(pathname: string, href: string): boolean {
  return pathname === href || (href !== '/' && href !== '/business' && pathname.startsWith(`${href}/`));
}
